<template>
  <div>
    <Head title="Picklist" />
    <h1 class="mb-8 text-3xl font-bold">Picked Orders</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-date-range v-model="form.search" class="mr-4 w-full max-w-md" />
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Queue
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Packed
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Picklist Number</th>
              <th class="pb-3 pt-3 px-3">Order No(s)</th>
              <th class="pb-3 pt-3 px-3">Customer Name</th>
              <th class="pb-3 pt-3 px-3 text-center">Total Quantity</th>
              <th class="pb-3 pt-3 px-3 text-end">Manage</th>
            </tr>
            <tr v-for="list in picklists.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                  {{ list.pick_list_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                  <span v-for="order in list.orders" :key="order">
                    {{ order.order }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                  <span v-for="customer in list.customers" :key="customer">
                    {{ customer.customer }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                  {{ list.quantity }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`dispatches/receive-picklist/${list.id}`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="picklists.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="6">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="picklists.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <div class="bg-white rounded-md shadow overflow-x-auto w-full">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-3 pt-3 px-3">Date</th>
                <th class="pb-3 pt-3 px-3">Picklist Number</th>
                <th class="pb-3 pt-3 px-3">Order No(s)</th>
                <th class="pb-3 pt-3 px-3">Customer Name</th>
                <th class="pb-3 pt-3 px-3 text-center">Total Quantity</th>
                <th class="pb-3 pt-3 px-3 text-end">Manage</th>
              </tr>
              <tr v-for="list in packed.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                <td class="border-t">
                  <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                    {{ list.date }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                    {{ list.pick_list_no }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                    <span v-for="order in list.orders" :key="order">
                      {{ order.order }}, 
                    </span>
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                    <span v-for="customer in list.customers" :key="customer">
                      {{ customer.customer }}, 
                    </span>
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`dispatches/receive-picklist/${list.id}`" title="">
                    {{ list.quantity }}
                  </Link>
                </td>
                <td class="w-px border-t">
                  <a :href="`dispatches/receive-picklist/${list.id}`" class="flex items-center justify-end pr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </a>
                </td>
              </tr>
              <tr v-if="packed.data.length === 0">
                <td class="px-3 py-3 border-t" colspan="6">No data found</td>
              </tr>
            </table>
          </div>
        </div>
        <pagination class="mt-6" :links="packed.links" />
      </div>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
    
export default {
  components: {
    Head,
    Link,
    SearchWithDateRange,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    picklists: Object,
    packed: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatches', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
  <style>
    .modal-wrapper h1 {
    font-size: 20px;
    font-weight:bold;
    margin-bottom: 10px;
    margin-top: 10px;
    }
    .approved {
    color: green;
    }
  </style>